export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function isTokenExpired(token, skewSeconds = 60) {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return true;
  return payload.exp < Date.now() / 1000 + skewSeconds;
}

export function getTokenExpiryMs(token) {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return 0;
  return payload.exp * 1000;
}

export function isTokenExpiringSoon(token, windowMs = 5 * 60 * 1000) {
  const expiry = getTokenExpiryMs(token);
  if (!expiry) return true;
  return expiry - Date.now() <= windowMs;
}
